import { useState } from 'react';

/**
 * Anexos que a pessoa já abriu nesta publicação — "Li e estou ciente" só libera depois de abrir
 * todos. Lembrado na sessão do navegador (fechou a aba, abre de novo).
 */
function chave(id: string) {
  return `si:anexosAbertos:${id}`;
}

function ler(id: string | undefined): string[] {
  try {
    return id ? (JSON.parse(sessionStorage.getItem(chave(id)) ?? '[]') as string[]) : [];
  } catch {
    return [];
  }
}

export function useAnexosAbertos(publicacaoId: string | undefined) {
  const [abertos, setAbertos] = useState<string[]>(() => ler(publicacaoId));
  const marcar = (path: string) =>
    setAbertos((atual) => {
      if (atual.includes(path)) return atual;
      const novos = [...atual, path];
      try {
        if (publicacaoId) sessionStorage.setItem(chave(publicacaoId), JSON.stringify(novos));
      } catch {
        // sem storage: vale só enquanto a página estiver aberta
      }
      return novos;
    });
  return { abertos, marcar };
}
